var React = require('react');

function Nextarrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.939453 12.28L5.28612 7.9333C5.79945 7.41997 5.79945 6.57997 5.28612 6.06664L0.939453 1.71997","stroke":"#292D32","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Nextarrow.defaultProps = {"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none"};

module.exports = Nextarrow;

Nextarrow.default = Nextarrow;
